import React from 'react';
import { Modal, ModalHeader } from '@razorpay/blade/components';
import { WizardInfoProvider } from 'components/WizardViews/providers';
import { FormProvider } from 'forms';
import { Wizard, WizardStep } from 'forms/Wizard';
import { CreateEmployeeLoansCategoryProps, EmployeeLoansCategoryFormData } from '../types';
import CategoryDetailsStep from './CategoryDetailsStep';
import PolicyDocumentStep from './PolicyDocumentStep';
import { INITIAL_FORM_DATA } from '../constants';

export const CreateEmployeeLoansCategory = ({
  isOpen,
  onClose,
  onSuccess,
  editCategory,
}: CreateEmployeeLoansCategoryProps) => {
  const handleSuccess = () => {
    onSuccess?.();
    onClose();
  };

  const initialFormData: EmployeeLoansCategoryFormData = editCategory
    ? {
        categoryName: editCategory.name,
        isDocumentRequired: editCategory.is_document_required,
        isCategoryCritical: editCategory.is_critical,
        policyDocumentFile: [],
        editCategoryId: editCategory.id,
        policyFileId: editCategory.policy_file_id ?? undefined,
        policySummary: editCategory.policy_summary ?? null,
      }
    : INITIAL_FORM_DATA;

  return (
    <Modal isOpen={isOpen} onDismiss={onClose} size="full">
      <ModalHeader title={editCategory ? 'Edit Category' : 'Create Category'} />
      <FormProvider<EmployeeLoansCategoryFormData> initialState={initialFormData}>
        <WizardInfoProvider
          initialStep={0}
          totalSteps={2}
          onWizardClose={onClose}
          onSuccess={handleSuccess}>
          <Wizard>
            <WizardStep step={0} component={CategoryDetailsStep} />
            <WizardStep step={1} component={PolicyDocumentStep} />
          </Wizard>
        </WizardInfoProvider>
      </FormProvider>
    </Modal>
  );
};

export default CreateEmployeeLoansCategory;
